export enum NotificationType {
  MentionedInMessage = 'mentioned-in-message',
  RepliedToMyMessage = 'replied-to-my-message',
  NewMessage = 'new-message',
  ExportedDatabase = 'exported-database',
  IncomingCall = 'incoming-call',
  DatabaseItemValueUpdated = 'database-item-value-updated',

  DatabaseItemCreated = 'database-item-created',
  UserAssignedToDatabaseItem = 'user-assigned-to-database-item',
  UserAssigneeChangedOnDatabaseItem = 'user-assignee-changed-on-database-item',
  StatusChangedOnDatabaseItem = 'status-changed-on-database-item',
  LabelChangedOnDatabaseItem = 'label-changed-on-database-item',
  DatabaseItemDeleted = 'database-item-deleted',

  CloudItemCreated = 'cloud-item-created',
  CloudItemDeleted = 'cloud-item-deleted',

  MentionedInDocument = 'mentioned-in-document',
  MentionedInMarkdown = 'mentioned-in-markdown',
  DatabaseItemFileCreated = 'database-item-file-created',
  DatabaseItemFileDeleted = 'database-item-file-deleted',

  WorkspaceAppAccessRequestPending = 'workspace-app-access-request-pending',
  WorkspacePermissionRequestPending = 'workspace-permission-request-pending',
  AppVersionPublished = 'app-version-published',
  AiApprovalRequested = 'ai-approval-requested',
  AiRunFinished = 'ai-run-finished',

  // Not implemented yet
  DatabaseItemDateChanged = 'date-changed-on-database-item',
  DatabaseItemStartDateReminder = 'database-item-start-date-reminder',
  DatabaseItemStartDateReached = 'database-item-start-date-reached',
  DatabaseItemEndDateReminder = 'database-item-end-date-reminder',
  DatabaseItemEndDatePassed = 'database-item-end-date-passed',
  
  // AutomationFailed = 'automation-failed',
  // AutomationQuotaExceeded = 'automation-quota-exceeded',

  // PaymentFailed = 'payment-failed',
  // PaymentReminder = 'payment-reminder',

  // CallStarted = 'call-started',
  // CallTranscriptionCompleted = 'call-transcription-completed',

  // FileQuotaExceeded = 'file-quota-exceeded',

  // TwoFactorConfirmationRequested = 'two-factor-confirmation-requested',
}

export const MENTION_NOTIFICATION_TYPES: NotificationType[] = [
  NotificationType.MentionedInMessage,
  NotificationType.MentionedInDocument,
  NotificationType.MentionedInMarkdown,
]
